/* eslint-disable */
export default [
    {
      path: '/monitor-center',
      name: 'MonitorCenter',
      component: () => import('@/layouts/main.vue'),
      children: [
        {
          path: 'redis-console/list',
          name: 'MonitorCenterRedisConsoleList',
          component: () => import('@/views/monitor-center/redis-console/list.vue'),
          meta: {
            title: 'Redis控制台',
            noCache: false,
            auth: true,
          },
        },
      ],
    },
    {
      path: '/monitor-center-kt',
      name: 'MonitorCenterKt',
      component: () => import('@/layouts/main.vue'),
      children: [
        {
          path: 'redis-console/list',
          name: 'MonitorCenterRedisKtConsoleList',
          component: () => import('@/views/monitor-center/redis-console-kt/list.vue'),
          meta: {
            title: 'Redis控制台KT',
            noCache: false,
            auth: true,
          },
        },
      ],
    },
  ];
  